import NotFound from './not-found';

export default NotFound;



// WEBPACK FOOTER //
// ./src/universal/components/not-found/index.js